import BackSection from "../../../Services/BackSection";
import { motion } from 'framer-motion';

export default function FailedToGetDetails({error, refetch}) {
  return (
    <>
      <BackSection pageName="Assignments" to={"/assignments"} />
      <motion.div
        className="container mt-5"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div
          className="text-center p-5 rounded-4"
          style={{
            border: '2px solid var(--hairline)',
            backgroundColor: 'white'
          }}
        >
          <div
            className="mx-auto mb-4 d-flex align-items-center justify-content-center"
            style={{
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              background: 'var(--danger-soft)'
            }}
          >
            <i className="fas fa-exclamation-triangle" style={{ fontSize: '2.5rem', color: 'var(--danger)' }}></i>
          </div>
          <h2 style={{ color: 'var(--ink)', fontWeight: '700', marginBottom: '12px' }}>
            Failed to Load Assignment
          </h2>
          <p style={{ color: 'var(--ink-soft)', marginBottom: '24px' }}>
            {error.message || "An error occurred while fetching the assignment details."}
          </p>
          <button
            className="btn px-5 py-2"
            onClick={() => refetch()}
            style={{
              backgroundColor: 'var(--accent)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '600'
            }}
          >
            <i className="fas fa-redo me-2"></i>
            Try Again
          </button>
        </div>
      </motion.div>
    </>
  )
}
